import { createContext, useContext } from "react";

export const ToolbarOptionsContext = createContext({
    setToolbarOptions: () => {},
});

export const useToolbarOptions = () => useContext(ToolbarOptionsContext);
